import * as http from '@/api/config/wyy';
import * as env from '@/env';


export function wyyLogin(data) {
    const url = 'login/cellphone';
    return http.$get(url, {
        phone: data.mobile,
        password: data.password,
    });
}


export function wyyGetLoginKey() {
    const url = 'login/qr/key';
    return http.$get(url, {
        timestamp: (new Date()).valueOf(),
    });
}

export function wyyGetLoginQrcode(key) {
    const url = 'login/qr/create';
    return http.$get(url, { 
        key: key,
        qrimg: 1,
        timestamp: (new Date()).valueOf(),
    });
}

export function wyyCheckQrcodeStatus(key) {
    const url = 'login/qr/check';
    return http.$get(url, {
        key: key,
        timestamp: (new Date()).valueOf(),
    });
}


/**
 * 获取音乐
 */
export function getMineWyyPlaylist() {
    const url = 'user/playlist';
    return http.$get(url, {
        uid: env.wyy.uid
    });
}

/**
 * 获取网易云歌单歌曲详情
 */
export function getWyyPlaylistDetail(id) {
    const url = 'playlist/detail';
    return http.$get(url, {
        id: id
    });
}

/* 获取音乐详情 */
export function getWyyMusicInfo(ids) {
    const url = 'song/detail';
    return http.$get(url, {
        ids: ids
    });
}
/* 获取歌曲Url */
export function getWyySongUrl(id) {
    const url = 'song/url';
    return http.$get(url, {
        id: id
    });
}
/* 获取歌词 */
export function getWyySongLyric(id) {
    const url = 'lyric';
    return http.$get(url, {
        id: id
    });
}

/**
 * 刷新token
 */
export function refreshWyyLoginStatus() {
    const url = 'login/refresh';
    return http.$get(url);
}


// WEBPACK FOOTER //
// ./src/api/module/music.js